<template>
    <div class="SPrintContent">
        <slot />
    </div>
</template>

<style lang="scss" scoped src="./index.scss" />
